let dropdownFormOptionsPerFormControl = {};

export class DatasourceOptionsService {
  public static setOptionsForForm(formControlName : string, options: any[]) {
    if (Array.isArray(options)) {
      dropdownFormOptionsPerFormControl[formControlName] = options;
    } else {
      dropdownFormOptionsPerFormControl[formControlName] = [];
    }
  }

  public static getOptionsForForm(formControlName : string) {
      if (dropdownFormOptionsPerFormControl[formControlName]) {
        return dropdownFormOptionsPerFormControl[formControlName];
      }
      return [];
  }
}